// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"4477a6e6","166":"ec3145b3","221":"ebb2bc2b","359":"ba0b91d1","450":"b67ea733","918":"694a6803"}[chunkId] + ".chunk.js";
};